module.exports = __webpack_public_path__ + "img/tool-second-section.81b40e96.webp";